import React from 'react'
import Reviewer from './Reviewer'

function Scholarship(props) {


    if(!props.data || props.data.length === 0){
        return (
            <div className='text-center mt-10'>
                <h2 className='text-2xl font-bold'>No Scholarship Application Data Available</h2>
            </div>
        )
    }
    
  return (

    <div className='font-mono'>


     {
        props.data.map((data,index) => ( 
            
          <div key={index} className='mb-4 border-solid border-black border-[1px] rounded-lg  shadow-2xl'>
      
          <h3 className="bg-blue-950 text-white    text-center text-3xl">
           <b> {data.scholarship_applied} </b>
          </h3>
    
          <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con rounded-lg">
            
            <ul>
                <li><b>Scholarship Type:</b> <span>{data.scholarship_applied} </span></li>
                <li><b>Graduation Type:</b> <span>{props.qualification}</span></li>
                <li><b>Scholarship Status:</b> <span> {data.award_status} </span></li>
                <li><b>Date Applied:</b> <span> {data.createdAtDate} </span></li>
           
            </ul>
    
          </div>
        </div>
          
        ) )
       }

   

    </div>
  )




}

export default Scholarship
